import { AfterViewInit, Component, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { MESSAGES } from 'src/app/core/constants/messages';
import { DataSharingService } from 'src/app/core/services/data-sharing/data-sharing.service';
import { FeedbackService } from 'src/app/core/services/feedback/feedback.service';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
})
export class LoadingComponent implements AfterViewInit, OnDestroy {
  @Input() global = false;
  @Input() loading = false;

  private loadingStateSubs: Subscription;
  private globalMaxTime = 10000;
  private globalMaxTimeout;

  constructor(
    private _dataSharingService: DataSharingService,
    private _feedbackService: FeedbackService,
  ) {}

  ngAfterViewInit(): void {
    this.watchGlobalLoadingState();
  }

  ngOnDestroy(): void {
    this.loadingStateSubs?.unsubscribe();
    clearTimeout(this.globalMaxTimeout);
  }

  watchGlobalLoadingState(): void {
    if (!this.global) {
      return;
    }
    this.loadingStateSubs = this._dataSharingService.loading$.subscribe((state) => {
      this.loading = state;
      if (this.loading) {
        this.stopByMaximumExecutionTime();
      }
    });
  }

  stopByMaximumExecutionTime(): void {
    clearTimeout(this.globalMaxTimeout);

    this.globalMaxTimeout = setTimeout(() => {
      if (this.loading) {
        this._feedbackService.warning(MESSAGES.WARNING.SLOW_PROCESSING);
      }
    }, this.globalMaxTime);
  }
}
